module.exports = __webpack_public_path__ + "static/images/point-up.2ae0997a4ec38f83b388ee05cafe7712.svg";